import { Component, input, linkedSignal, output, viewChildren } from '@angular/core';
import { SupplierContractCheckData } from '../../stores/supplier-contract-checks.store';
import { NgIcon } from '@ng-icons/core';
import { SupplierContractCheckItemFormField } from '../supplier-contract-check-item-form-field/supplier-contract-check-item-form-field';
import { SupplierContractCheckItemRequest } from '../../../../core/clients/omni-core/models';
import { SupplierContractCheckFormModel, toModel } from './definitions';
import { form, FormField, validate } from '@angular/forms/signals';
import { FieldErrors } from '../../../../shared/components/field-errors/field-errors';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-supplier-contract-check-edit-form',
  imports: [NgIcon, SupplierContractCheckItemFormField, FormField, FieldErrors, TranslocoPipe],
  templateUrl: './supplier-contract-check-edit-form.html',
})
export class SupplierContractCheckEditForm {
  organizationId = input.required<string>();
  data = input.required<SupplierContractCheckData>();

  changeData = output<SupplierContractCheckFormModel>();

  private items = viewChildren(SupplierContractCheckItemFormField);

  model = linkedSignal(() => toModel(this.data()));
  form = form(this.model, (schemaPath) => {
    const fields: (keyof SupplierContractCheckFormModel)[] = [
      'CHECK_CONSUMPTION_FLEXIBILITY',
      'CHECK_CONTRACT_FLEXIBILITY',
      'CHECK_DECISION_MAKING_EFFORT',
      'CHECK_FIX_COST',
      'CHECK_FIX_PRICE_GUARANTEE',
      'CHECK_INDEX_PRICE_DEPENDENCY',
      'CHECK_MARGIN_TRANSPARENCY',
      'CHECK_OVERALL_COST',
      'CHECK_PRICE_CONSUMPTION_MATCH',
      'CHECK_PRICING_BILLING_COMPLEXITY',
      'CHECK_TRANCHE_TIMING_PERFORMANCE',
    ];
    for (const field of fields) {
      validate(schemaPath[field].result, (schemaPath) =>
        schemaPath.value() === 'NOT_SET' ? { kind: 'resultRequired' } : null,
      );
      validate(schemaPath[field], (schemaPath) =>
        (schemaPath.value().result === 'ALERT' || schemaPath.value().result === 'INFO') &&
        !schemaPath.value().explanation
          ? { kind: 'explanationRequired' }
          : null,
      );
    }
  });

  protected onChangeItem(
    id: keyof SupplierContractCheckFormModel,
    value: SupplierContractCheckItemRequest | null,
  ) {
    this.changeData.emit({
      ...this.form().value(),
      [id]: value,
    });
  }

  markAsTouched() {
    this.form.CHECK_OVERALL_COST.result().markAsTouched();
    this.form.CHECK_PRICE_CONSUMPTION_MATCH.result().markAsTouched();
    this.form.CHECK_FIX_COST.result().markAsTouched();
    this.form.CHECK_INDEX_PRICE_DEPENDENCY.result().markAsTouched();
    this.form.CHECK_TRANCHE_TIMING_PERFORMANCE.result().markAsTouched();
    this.form.CHECK_CONSUMPTION_FLEXIBILITY.result().markAsTouched();
    this.form.CHECK_MARGIN_TRANSPARENCY.result().markAsTouched();
    this.form.CHECK_PRICING_BILLING_COMPLEXITY.result().markAsTouched();
    this.form.CHECK_FIX_PRICE_GUARANTEE.result().markAsTouched();
    this.form.CHECK_DECISION_MAKING_EFFORT.result().markAsTouched();
    this.form.CHECK_CONTRACT_FLEXIBILITY.result().markAsTouched();
    this.items().forEach((item) => item.markAsTouched());
  }
}
